{
  "app": {
    "title": "EddanRPG Maps",
    "subtitle": "Team map editor — zones, places, spawns and quests in Unity coordinates",
    "noMaps": "No maps yet"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "close": "Close",
    "apply": "Apply",
    "add": "Add",
    "reset": "Reset",
    "loading": "Loading…",
    "copied": "Copied to clipboard",
    "name": "Name",
    "key": "Key",
    "description": "Description",
    "tags": "Tags",
    "all": "all",
    "none": "none",
    "someone": "someone"
  },
  "roles": {
    "admin": "Admin",
    "editor": "Editor",
    "viewer": "Viewer"
  },
  "login": {
    "email": "Email",
    "password": "Password",
    "submit": "Sign in",
    "failed": "Sign-in failed",
    "hint": "Accounts are created by an admin. Ask Niklas if you need one."
  },
  "top": {
    "map": "Map",
    "searchPlaceholder": "Search by name, key or tag — or paste coordinates",
    "jumpTo": "Go to X {{x}}, Z {{z}}",
    "noResults": "Nothing found",
    "language": "Language",
    "logout": "Sign out",
    "realtime": {
      "connecting": "Connecting…",
      "connected": "Live — changes from others appear instantly",
      "offline": "Offline — reconnecting"
    },
    "views": {
      "map": "Map",
      "data": "Game data"
    }
  },
  "left": {
    "draw": "Draw",
    "tools": "Tools",
    "layers": "Layers",
    "noBaseLayers": "No map images yet. An admin can upload one under Admin → Layers.",
    "opacity": "Opacity",
    "overlays": "Overlays",
    "filters": "Filters",
    "featureTypes": "Types",
    "statuses": "Status",
    "onlyMine": "Only things I created",
    "tagFilter": "Filter by tag",
    "queue": "Implementation queue",
    "queueEmpty": "Nothing waiting for Unity"
  },
  "overlays": {
    "chunkGrid": "Chunk grid (scene names)",
    "grid100": "100 m grid",
    "asBuilt": "Unity as-built outlines",
    "labels": "Labels",
    "questRoutes": "Quest routes"
  },
  "tools": {
    "measure": "Measure",
    "pick": "Pick coordinate",
    "measureHint": "Click to measure a distance. Esc clears.",
    "measureValue": "{{length}} m — area of the closed shape {{area}} m² — Esc clears",
    "pickHint": "Click the map to copy a Unity Vector3 to the clipboard",
    "copiedValue": "Copied {{value}}",
    "editHint": "Drag the corners to reshape, drag the shape to move. Changes save automatically. Esc to finish.",
    "drawHint": {
      "point": "Click to place. Esc cancels.",
      "circle": "Click the centre, then click again to set the radius. Esc cancels.",
      "rect": "Click one corner, then the opposite corner. Esc cancels.",
      "polygon": "Click to add corners, click the first corner to finish. Esc cancels.",
      "polyline": "Click to add points, click the last point again to finish. Esc cancels."
    }
  },
  "groups": {
    "areas": "Areas",
    "places": "Places",
    "characters": "Characters",
    "mobs": "Mobs",
    "quests": "Quests",
    "objects": "Objects",
    "annotations": "Notes & paths"
  },
  "types": {
    "zone": "Zone",
    "mob_spawn_area": "Mob spawn area",
    "mob_spawn_point": "Mob spawn point",
    "npc": "NPC",
    "poi": "Point of interest",
    "quest": "Quest",
    "quest_step": "Quest step",
    "quest_location": "Quest location trigger",
    "resource_node": "Resource / herb",
    "altar": "Altar",
    "loot_container": "Chest / container",
    "interactable": "Interactable",
    "respawn_point": "Respawn point",
    "player_start": "Player start",
    "patrol_area": "Patrol area",
    "path": "Path",
    "note": "Note"
  },
  "presets": {
    "village": "Village / city",
    "forest": "Forest",
    "meadows": "Meadows",
    "lake": "Lake",
    "coastal": "Coast",
    "landmark": "Landmark",
    "dungeon": "Dungeon / cave",
    "npc": "NPC",
    "mob_area": "Spawn area",
    "mob_point": "Spawn point",
    "quest": "Quest",
    "quest_step": "Quest step",
    "quest_area": "Quest trigger",
    "herb_patch": "Herb patch",
    "resource": "Resource node",
    "altar": "Altar",
    "chest": "Chest",
    "interactable": "Interactable",
    "respawn": "Respawn point",
    "player_start": "Player start",
    "patrol_area": "Patrol area",
    "road": "Road",
    "river": "River",
    "note": "Note",
    "note_area": "Note area"
  },
  "status": {
    "idea": "Idea",
    "proposed": "Proposed",
    "approved": "Approved",
    "in_unity": "In Unity",
    "needs_update": "Needs update",
    "deprecated": "Deprecated"
  },
  "sync": {
    "unlinked": "Not linked",
    "in_sync": "Matches Unity",
    "design_ahead": "Design changed",
    "unity_ahead": "Unity changed",
    "conflict": "Conflict",
    "missing_in_unity": "Missing in Unity"
  },
  "inspector": {
    "tabs": {
      "properties": "Properties",
      "geometry": "Shape",
      "unity": "Unity",
      "comments": "Comments",
      "history": "History"
    },
    "to": {
      "idea": "Back to idea",
      "proposed": "Propose",
      "approved": "Approve",
      "in_unity": "Mark as in Unity",
      "needs_update": "Needs update",
      "deprecated": "Deprecate"
    },
    "setStatus": "Set status…",
    "statusAuto": "Saved — status is now “{{status}}”",
    "zoomTo": "Zoom to",
    "editShape": "Edit shape",
    "doneEditing": "Done",
    "copyLink": "Copy link",
    "confirmDelete": "Delete “{{name}}”? This cannot be undone.",
    "removeGone": "Remove from the tool",
    "confirmRemoveGone": "Remove “{{name}}” from the tool? It is no longer in Unity. Its comments go with it; the history log keeps a record. If it comes back in Unity, the next import adds it again as new.",
    "conflict": "{{name}} changed this while you were editing.",
    "reloadTheirs": "Load their version",
    "applyMine": "Apply my change on top",
    "keyLocked": "locked — in Unity",
    "keyFromName": "Make key from name",
    "parent": "Belongs to",
    "showInGame": "Show on the in-game map",
    "color": "Colour",
    "tagsHint": "comma separated",
    "unsaved": "Unsaved changes",
    "designOnly": "design",
    "attachments": "Images & files",
    "addFiles": "Add images or files",
    "createdBy": "Created by {{name}}",
    "updatedBy": "last edit {{name}}"
  },
  "props": {
    "zoneId": "Zone id",
    "zoneType": "Zone type",
    "priority": "Priority",
    "exitMargin": "Exit margin (m)",
    "unrevealedName": "Name before discovery",
    "bannerSubtitle": "Banner subtitle",
    "bannerColor": "Banner colour",
    "lightingProfile": "Lighting profile",
    "revealAfterQuest": "Revealed after quest",
    "linkedSpawnZone": "Linked spawn area",
    "levelMin": "Level from",
    "levelMax": "Level to",
    "mood": "Mood & look",
    "mode": "Spawn mode",
    "randomSpawns": "Mobs",
    "mob": "Mob prefab",
    "weight": "Weight",
    "maxCount": "Max",
    "respawnTime": "Respawn (s)",
    "cellSize": "Cell size (m)",
    "cellSpawnChance": "Cell chance",
    "maxPerCell": "Max per cell",
    "activationRadius": "Activation radius (m)",
    "despawnRadius": "Despawn radius (m)",
    "wanderRadius": "Wander radius (m)",
    "exclusionZones": "Excluded zones",
    "density": "Density",
    "movement": "Movement",
    "patrolPath": "Patrol path",
    "actorId": "Actor id",
    "title": "Title",
    "prefab": "Prefab",
    "roles": "Roles",
    "merchantId": "Merchant id",
    "trainerId": "Trainer id",
    "recipeTrainerId": "Recipe trainer id",
    "factionId": "Faction",
    "patrolArea": "Patrol area",
    "patrolRadius": "Patrol radius (m)",
    "personality": "Personality & story",
    "poiId": "POI id",
    "poiType": "POI type",
    "markerColor": "Marker colour",
    "showLabel": "Show label",
    "icon": "Icon id",
    "questID": "Quest id",
    "category": "Category",
    "requiredLevel": "Required level",
    "giverNpc": "Quest giver",
    "turnInNpc": "Turn in to",
    "mapZone": "Map zone",
    "mapPoi": "Map POI",
    "repeatable": "Repeatable",
    "prerequisites": "Prerequisite quests",
    "rewardsIdea": "Reward ideas",
    "stepIndex": "Step number",
    "objectiveType": "Objective",
    "target": "Target",
    "requiredCount": "Count",
    "optional": "Optional",
    "location": "Location",
    "locationTag": "Location tag",
    "destroyOnEnter": "Remove trigger once entered",
    "height": "Trigger height (m)",
    "spawnTargetId": "Target id",
    "spawnPrefab": "Spawn prefab",
    "harvestTypeId": "Harvest type",
    "note": "Note",
    "count": "How many",
    "lootIdea": "Loot ideas",
    "purpose": "Kind",
    "width": "Width (m)"
  },
  "enums": {
    "zoneType": {
      "Village": "Village",
      "Forest": "Forest",
      "Lake": "Lake",
      "Meadows": "Meadows",
      "Coastal": "Coastal"
    },
    "mode": {
      "Random": "Random (seeded cells)",
      "Defined": "Defined spawn points"
    },
    "density": {
      "sparse": "Sparse",
      "normal": "Normal",
      "dense": "Dense"
    },
    "movement": {
      "Wander": "Wander",
      "Waypoints": "Waypoints"
    },
    "roles": {
      "QuestGiver": "Quest giver",
      "Merchant": "Merchant",
      "Trainer": "Trainer",
      "RecipeTrainer": "Recipe trainer",
      "Dialogue": "Dialogue",
      "SequenceActor": "Cutscene actor"
    },
    "poiType": {
      "Landmark": "Landmark",
      "Merchant": "Merchant",
      "SpawnPoint": "Spawn point",
      "Home": "Home",
      "QuestGiver": "Quest giver",
      "Dungeon": "Dungeon"
    },
    "objectiveType": {
      "Kill": "Kill",
      "Collect": "Collect",
      "UseItem": "Use item",
      "Produce": "Produce",
      "TalkToNPC": "Talk to NPC",
      "Escort": "Escort",
      "GoToLocation": "Go to location",
      "CustomEvent": "Custom event",
      "Harvest": "Harvest"
    },
    "purpose": {
      "road": "Road",
      "trail": "Trail",
      "river": "River",
      "patrol": "Patrol route",
      "quest_route": "Quest route"
    }
  },
  "geometry": {
    "kind": "Shape",
    "kinds": {
      "point": "Point",
      "circle": "Circle",
      "rect": "Rectangle",
      "polygon": "Polygon",
      "polyline": "Line",
      "none": "No shape"
    },
    "position": "Position",
    "center": "Centre",
    "chunk": "Chunk scene",
    "area": "Area",
    "perimeter": "Perimeter",
    "length": "Length",
    "vertices": "Corners",
    "yUnknown": "Height (Y) unknown until a heightmap is imported — Unity will snap to the ground.",
    "copyVector3": "Copy Vector3 (Inspector)",
    "copyCSharp": "Copy C# Vector3",
    "copyPoints": "Copy points JSON",
    "fields": {
      "x": "X",
      "z": "Z",
      "rotY": "Rotation Y°",
      "r": "Radius",
      "w": "Width (X)",
      "d": "Depth (Z)"
    }
  },
  "unity": {
    "designOnlyType": "Notes are design-only and never go to Unity.",
    "asset": "ScriptableObject asset",
    "component": "Component",
    "scene": "Scene",
    "idField": "Unity id ({{field}})",
    "link": "Link",
    "hierarchy": "Hierarchy",
    "unityPosition": "In Unity",
    "geometry": "Shape",
    "design": "Design",
    "takeUnity": "Take Unity's version",
    "keepDesign": "Keep design (Unity must change)",
    "unlink": "Unlink",
    "confirmUnlink": "Forget the link to the Unity object? The feature stays; the next import may adopt the object as a new feature.",
    "explain": {
      "unlinked": "Not linked to a Unity object yet. Approve it, build it in Unity, then import from Unity (or mark it as in Unity).",
      "in_sync": "The design and Unity match.",
      "design_ahead": "The design changed after it was built. Unity needs updating.",
      "unity_ahead": "Unity changed but the design didn't. The next import will update the design.",
      "conflict": "Both the design and Unity changed. An admin must choose which version wins.",
      "missing_in_unity": "The linked object was not in the latest Unity export — deleted or renamed?"
    }
  },
  "comments": {
    "empty": "No comments yet.",
    "placeholder": "Write a comment…",
    "post": "Post",
    "ctrlEnter": "Ctrl+Enter to post",
    "resolve": "Resolve",
    "reopen": "Reopen",
    "confirmDelete": "Delete this comment?",
    "showResolved": "Show {{count}} resolved",
    "hideResolved": "Hide resolved"
  },
  "history": {
    "empty": "No history yet.",
    "restore": "Restore this version",
    "confirmRestore": "Restore the content as it was on {{date}}? Status and key are not changed.",
    "system": "System",
    "actions": {
      "create": "Created",
      "update": "Edited",
      "delete": "Deleted",
      "status": "Status",
      "import": "Unity import",
      "restore": "Restored",
      "rekey": "Key changed"
    },
    "fields": {
      "type": "type",
      "key": "key",
      "name": "name",
      "description": "description",
      "geometry": "shape",
      "properties": "properties",
      "designProps": "design notes",
      "status": "status",
      "showInGame": "in-game map",
      "parent": "belongs to",
      "tags": "tags",
      "color": "colour",
      "sortOrder": "order",
      "unityKey": "Unity link"
    }
  },
  "admin": {
    "title": "Admin",
    "tabs": {
      "layers": "Layers",
      "import": "Import from Unity",
      "export": "Export",
      "users": "Users",
      "gamedata": "Import game data",
      "fields": "Fields",
      "dataexport": "Export to Unity"
    },
    "layers": {
      "empty": "No base layers yet.",
      "exact": "Exact placement (Unity render)",
      "fitted": "Calibrated with {{n}} points, error {{rms}} m",
      "uncalibrated": "Not calibrated — stretched over the whole world",
      "visibleByDefault": "Visible by default",
      "up": "Draw above",
      "down": "Draw below",
      "calibrate": "Calibrate",
      "confirmDelete": "Delete the layer “{{name}}”?",
      "upload": "Upload a map image",
      "source": "Source",
      "sources": {
        "unity_render": "Unity render",
        "painted": "Painted map",
        "sketch": "Sketch",
        "other": "Other"
      },
      "presetFound": "Recognised as the Startland painted map — it will be placed with the measured fit.",
      "stretchNote": "It will be stretched over the whole world first; calibrate it afterwards.",
      "uploadButton": "Upload",
      "uploaded": "Layer uploaded",
      "notAnImage": "That file can't be read as an image"
    },
    "import": {
      "help": "In Unity run EnyaRPG → World → Maps Editor → Export Startland, then pick the files from Builds/MapsEditorExport/…. Check first, then apply.",
      "render": "Top-down render",
      "heights": "Heightmap",
      "badJson": "That file isn't valid JSON",
      "dirty": "uncommitted changes",
      "wrongWorld": "This export is for {{got}}, but the open map is {{want}}.",
      "fastForward": "Update features that only changed in Unity",
      "dryRun": "Check (dry run)",
      "apply": "Apply import",
      "planTitle": "What the import will do",
      "resultTitle": "Import done",
      "renderLayerName": "Unity top-down",
      "done": "Import applied",
      "warnings": "Warnings",
      "counts": {
        "objects": "Objects in export",
        "adopted": "New features (adopted)",
        "linked": "Newly linked",
        "inSync": "Already matching",
        "fastForwarded": "Updated from Unity",
        "designAhead": "Design changed (needs update)",
        "conflicts": "Conflicts",
        "missing": "Missing in Unity",
        "skipped": "Skipped"
      },
      "actions": {
        "adopted": "new",
        "in_sync": "linked",
        "design_ahead": "design ahead",
        "fast_forwarded": "updated",
        "unity_ahead": "Unity ahead",
        "conflict": "conflict",
        "missing_in_unity": "missing"
      }
    },
    "export": {
      "help": "Exports use Unity world metres (X east, Z north) and stable keys.",
      "full": "Download full export",
      "fullHelp": "Everything, with Unity mapping and sync state — input for the future Unity importer.",
      "ingame": "Download in-game map export",
      "ingameHelp": "Only approved zones and POIs marked “Show on the in-game map”.",
      "snapshot": "Git snapshot",
      "snapshotHelp": "Writes data/<map>/export.json and export.ingame.json for review and commit."
    },
    "users": {
      "resetPassword": "Reset password",
      "confirmReset": "Set a new password for {{name}}?\n\n{{password}}\n\nIt will be copied to your clipboard.",
      "passwordCopied": "New password copied — send it to them privately",
      "new": "New account",
      "role": "Role",
      "passwordHint": "Email and password are copied to your clipboard when you create the account.",
      "create": "Create account",
      "created": "Account created — login details copied"
    },
    "gamedata": {
      "help": "Run EnyaRPG → World → Maps Editor → Export game data in Unity after every release. Pick unity-data.json and all PNG files in the icons folder under Builds/MapsEditorExport/gamedata/…. Dry-run first, then apply.",
      "badFile": "This is not a game-data export (unity-data.json)",
      "done": "Game data imported",
      "icons": "Icons (select all PNG files in the icons folder)",
      "summary": "{{assets}} assets, {{icons}} icons",
      "iconsMatched": "{{matched}} of {{total}} icons are among the selected files",
      "iconProgress": "Uploading icons: {{done}} of {{total}}",
      "initial": "First import: every field gets its default setting. Adjust what designers see under Fields.",
      "schemaTitle": "Changes in the Unity code",
      "classAdded": "New class: {{name}}",
      "classRemoved": "Class {{name}} no longer exists",
      "fieldAdded": "New field {{owner}}.{{name}} ({{kind}})",
      "fieldRenamed": "{{owner}}.{{from}} is now {{to}} — values and settings move along",
      "fieldRemoved": "{{owner}}.{{name}} was removed",
      "fieldChanged": "{{owner}}.{{name}} changed type: {{from}} → {{to}}",
      "enumChanged": "Value list {{name}}: added {{added}}, removed {{removed}}",
      "reviewNew": "New fields are marked “New” under Fields until you review them.",
      "changes": "Changed assets",
      "counts": {
        "assets": "Assets in the export",
        "adopted": "New (adopted)",
        "inSync": "Already in sync",
        "fastForwarded": "Updated from Unity",
        "designAhead": "Design changed (needs update)",
        "conflicts": "Conflicts",
        "missing": "Missing in Unity",
        "skipped": "Skipped"
      },
      "actions": {
        "adopted": "new",
        "in_sync": "in sync",
        "fast_forwarded": "updated",
        "design_ahead": "design ahead",
        "conflict": "conflict",
        "missing_in_unity": "missing",
        "linked": "linked"
      }
    },
    "fields": {
      "help": "Decide what designers see of each class. A setting belongs to the class that declares the field, so Item Data also covers food and equipment. Hidden fields are Unity tuning that only admins see.",
      "onlyNew": "Only new fields",
      "nested": "nested",
      "newCount": "{{count}} new",
      "markAllSeen": "Mark all as reviewed",
      "markSeen": "Reviewed",
      "labels": "Labels and help text",
      "labelSv": "Label (Swedish)",
      "labelEn": "Label (English)",
      "helpSv": "Help text (Swedish)",
      "helpEn": "Help text (English)",
      "section": "Section",
      "visibility": {
        "edit": "Editable",
        "readonly": "Read-only",
        "hidden": "Hidden (Unity tuning)"
      },
      "picker": "Input",
      "pickers": {
        "free": "Free text",
        "vocab": "Free text with suggestions from Unity",
        "vocab_strict": "Only values that already exist in Unity",
        "auto": "Automatic (map or suggestions where it fits)",
        "map_zone": "Zone on the map (zoneId)",
        "map_poi": "Place on the map (poiId)",
        "map_quest_location": "Quest location on the map (locationTag)",
        "map_npc": "NPC on the map (name)"
      },
      "suggest": "Suggest visibility ({{count}})",
      "suggestHelp": "Sets the fields to what the rules suggest today, e.g. hiding Unity tuning such as hideLayer or castAnimationTrigger.",
      "confirmSuggest": "Change the visibility of {{count}} field(s) as suggested?"
    },
    "dataexport": {
      "help": "Approved changes become a change package. Open the .json in Unity with EnyaRPG → World → Maps Editor → Apply change package…, and read the .md for an overview. Changes become “In Unity” once the next export from Unity has been imported.",
      "nothing": "No approved changes to send right now.",
      "create": "Create change package ({{count}})",
      "confirm": "Create a change package with {{count}} asset(s)? Two files download: the .json for Unity and a .md to read.",
      "done": "Change package downloaded",
      "earlier": "Earlier packages",
      "assets": "{{count}} asset(s)",
      "download": "Download again",
      "keyWarning": "renames a name that player saves use",
      "progressWarning": "Moves saved progress ({{where}}): the game saves a player's place in the quest by step and objective position, so anyone with this quest in progress lands on another step or objective.",
      "comments": "{{count}} open comment(s) included",
      "added": "added",
      "removed": "removed",
      "copyOf": "copy of {{name}}"
    }
  },
  "calibration": {
    "title": "Calibrate",
    "help": "Line the image up with the world. Turn on the Unity render underneath, then add control points: click a spot on this image, then click where that spot really is. Two points are enough; three or more show the error.",
    "addPoint": "Add control point",
    "stopPicking": "Stop adding points",
    "stretch": "Stretch over world",
    "preset": "Use measured fit",
    "scaleX": "Scale X (m/px)",
    "offsetX": "Offset X",
    "scaleZ": "Scale Z (m/px)",
    "offsetZ": "Offset Z",
    "error": "Error",
    "rms": "Average error {{rms}} m",
    "rotationWarning": "The points suggest the image is rotated {{deg}}° — rotation isn't supported yet.",
    "save": "Save calibration",
    "saved": "Calibration saved",
    "clickImage": "Click a recognisable spot on the image being calibrated",
    "clickWorld": "Now click where that spot really is (on the Unity render)"
  },
  "errors": {
    "stale_revision": "Someone else changed this in the meantime.",
    "rev_required": "The app sent an update without a revision — reload the page.",
    "status_transition_denied": "Only an admin can set that status.",
    "key_locked": "The key is locked once something is in Unity.",
    "key_prefix": "The key must start with the map's prefix.",
    "geometry_invalid": "The shape is invalid.",
    "geometry_kind_not_allowed": "That shape isn't allowed for this type.",
    "property_invalid": "A property has an invalid value.",
    "type_invalid": "Unknown type.",
    "type_locked": "The type can't change once linked to Unity.",
    "map_immutable": "A feature can't move to another map.",
    "parent_invalid": "It can't belong to that.",
    "delete_denied": "Editors can only delete their own ideas and proposals.",
    "delete_linked": "Things in Unity are deprecated, not deleted.",
    "admin_only": "Only admins can do that.",
    "role_change_denied": "Only an admin can change roles.",
    "map_not_found": "Map not found.",
    "not_linked": "Not linked to a Unity object.",
    "resolve_action": "Unknown action.",
    "import_schema": "That isn't a Unity export from the Maps Editor exporter.",
    "import_version": "That export has an unsupported version.",
    "import_world": "That export is for a different world.",
    "import_objects": "The export has no objects list.",
    "network": "Can't reach the server.",
    "unauthorized": "Your session expired — sign in again.",
    "rate_limited": "Too many attempts — wait a moment.",
    "value_invalid": "Invalid value: {{detail}}",
    "category_readonly": "This category can’t be edited here yet.",
    "record_deprecated": "Deprecated records can’t be changed.",
    "key_required": "The name can’t be empty.",
    "key_taken": "The name is already used: {{detail}}",
    "not_in_unity": "Only an import from Unity can confirm the change is in Unity.",
    "export_empty": "There are no approved changes to send.",
    "comment_target": "The comment has no target.",
    "category_missing": "The category does not exist.",
    "template_missing": "Pick something in the same category to start from.",
    "asset_name_invalid": "The file name may only contain letters, digits, spaces and _ - ( ).",
    "asset_path_invalid": "The file must be under Assets/ and be named like the file name.",
    "asset_path_taken": "A file with that name already exists.",
    "record_referenced": "Something else still uses it: {{detail}}",
    "ref_cycle": "That would make a loop: {{detail}}"
  },
  "data": {
    "title": "Game data",
    "intro": "The game’s data from Unity: items, enemies, quests, dialogue and more. Propose changes, create new things and write dialogue — Niklas approves and carries them into the game.",
    "lastImport": "Last synced from Unity {{date}}",
    "empty": "No game data yet. An admin imports it from Unity.",
    "importNow": "Import game data",
    "search": "Search all game data",
    "results": "{{count}} results",
    "filters": {
      "journalRegion": "Journal Region",
      "location": "Location",
      "all": "All",
      "unset": "(none)",
      "clear": "Clear filters",
      "showing": "{{shown}} of {{total}}"
    },
    "hiddenFields": "Hidden Unity fields ({{count}}) — admins only",
    "newField": "New",
    "yes": "Yes",
    "no": "No",
    "unityOnly": "(Unity only)",
    "showAll": "Show all {{count}}",
    "missingRef": "missing",
    "missingBanner": "This was not in the latest export from Unity. It may have been deleted or moved.",
    "conflictBanner": "Both the design and Unity changed: {{fields}}. An admin decides which version wins.",
    "usedByNone": "Nothing else points here.",
    "tabs": {
      "properties": "Properties",
      "usedBy": "Used by",
      "unity": "Unity",
      "history": "History",
      "comments": "Comments"
    },
    "unity": {
      "path": "File in Unity",
      "class": "Class",
      "sync": "Sync",
      "lastImport": "Last import",
      "differs": "Differs from Unity",
      "design": "Design"
    },
    "categories": {
      "items": "Items",
      "equipment": "Equipment",
      "mob_stats": "Mob stats",
      "mobs": "Mobs",
      "loot_tables": "Loot tables",
      "quests": "Quests",
      "dialogue": "Dialogue",
      "merchants": "Merchants",
      "spells": "Spells",
      "spell_effects": "Spell effects",
      "altar_effects": "Altar effects",
      "classes": "Classes",
      "recipes": "Crafting recipes",
      "factions": "Factions"
    },
    "changes": "Changes",
    "edit": {
      "unityHas": "In Unity:",
      "choose": "— choose —",
      "clear": "Clear",
      "up": "Move up",
      "down": "Move down",
      "keyLocked": "Locked: player saves use this name. Only an admin can change it.",
      "confirmProgressMove": "This quest is in Unity. The game saves players' place in the quest by step and objective position, so moving or deleting steps or objectives puts anyone who has it in progress in the wrong place. Continue?",
      "loadTheirs": "Load their version",
      "mineOnTop": "Put my changes on top",
      "note": "Note to Niklas",
      "notePlaceholder": "E.g. “needs a new icon”, or why the change is needed",
      "unsaved": "Unsaved changes",
      "readOnlyCategory": "This category can’t be edited here yet.",
      "entries": "{{count}} entries",
      "show": "show",
      "notOnMap": "Not on the map yet."
    },
    "review": {
      "to_proposed": "Mark as proposal",
      "to_idea": "Mark as idea",
      "approve": "Approve",
      "unapprove": "Undo approval",
      "reject": "Reject the change",
      "takeUnity": "Take Unity’s version",
      "keepDesign": "Keep the design",
      "confirmReject": "Reject the changes to “{{name}}”? The values go back to what Unity has. History is kept.",
      "removeGone": "Remove from the tool",
      "confirmRemoveGone": "Remove “{{name}}” from the tool? It is no longer in Unity. Its comments and any unsent changes go with it; the history log keeps a record. If it comes back in Unity, the next import adds it again as new.",
      "changedBy": "Changed by {{name}}",
      "approvedBy": "approved by {{name}}",
      "exported": "sent to Unity {{date}} — confirmed by the next import"
    },
    "create": {
      "button": "New",
      "title": "New asset",
      "help": "Pick an existing one to start from. The new one becomes a copy in Unity — icon, model and everything not shown here come along — and you change what should differ.",
      "template": "Start from",
      "key": "Name in the game ({{field}})",
      "assetName": "File name in Unity",
      "folder": "Folder in Unity",
      "willBe": "Created as",
      "create": "Create",
      "done": "Created — change what should differ and save",
      "newBadge": "New",
      "pending": "New: created in Unity as {{path}} (copy of {{template}})",
      "confirmDelete": "Delete “{{name}}”? It isn’t in Unity yet, so nothing else is affected."
    },
    "dialogue": {
      "preview": "Preview the dialogue",
      "page": "Page {{n}}",
      "pageOf": "Page {{n}} of {{of}}",
      "close": "Close the dialogue",
      "continue": "Continue",
      "closed": "Closed",
      "closedHint": "The dialogue has ended.",
      "restart": "Start over",
      "skip": "Click to show all of the text",
      "confirmDeleteTarget": "{{count}} choice(s) on other pages go to page {{n}}. If you delete it, they close the dialogue instead. Delete the page?"
    },
    "table": {
      "count": "{{count}}",
      "filter": "Filter…",
      "columns": "Columns ({{shown}}/{{all}})",
      "help": "Click a row to open it. Click a heading to sort.",
      "helpEdit": "Click a row to open it, a heading to sort. Numbers and checkboxes can be changed right here — they are saved as proposals. Marked cells differ from Unity.",
      "status": "Status",
      "min": "Lowest",
      "median": "Median",
      "max": "Highest",
      "noChanges": "Nothing is waiting right now.",
      "category": "Category",
      "what": "Changed",
      "who": "Changed by",
      "sent": "Sent to Unity",
      "back": "Back to {{name}}"
    },
    "sheet": {
      "viewLabel": "View",
      "view": {
        "table": "Table",
        "sheet": "Sheet",
        "tableHint": "One row per record, for balancing numbers",
        "sheetHint": "Spreadsheet: one row per step or page, text edited in place, every column filterable"
      },
      "count": "{{records}} records · {{rows}} rows",
      "search": "Search all columns…",
      "onlyChanged": "Only changed",
      "onlyChangedHint": "Rows that differ from Unity, or are new",
      "fullText": "Full text",
      "fullTextHint": "Show all of every long text (otherwise 4 lines; the selected cell always shows all)",
      "help": "Click a cell to select it; Shift or dragging selects more. Double-click, Enter or just typing edits — Enter saves, Esc cancels, Shift+Enter makes a new line in long text. Ctrl+C / Ctrl+V copy and paste with Excel and Google Sheets. Edits are saved as proposals; orange cells differ from Unity, and ↺ puts Unity's value back.",
      "helpOwn": "Difficulty and Notes (in italics) stay in this tool.",
      "readOnlyCategory": "This category can’t be edited on the web yet, according to the last import from Unity, so its values are read-only here. A newer import changes that.",
      "ownStillEditable": "Difficulty and Notes can still be filled in.",
      "helpRead": "Click a cell to select it; Shift or dragging selects more, and Ctrl+C copies for Excel and Google Sheets. Orange cells differ from Unity.",
      "col": {
        "step": "Step",
        "page": "Page",
        "objectiveTypes": "Objective type",
        "factions": "Faction",
        "difficulty": "Difficulty",
        "notes": "Notes",
        "choices": "Choices",
        "status": "Status",
        "changedBy": "Changed by"
      },
      "options": {
        "difficulty": {
          "easy": "Easy",
          "medium": "Medium",
          "hard": "Hard"
        }
      },
      "ownHint": "Only in this tool — never sent to Unity",
      "na": "N/A",
      "ends": "end",
      "toPage": "page {{n}}",
      "scene": "scene",
      "open": "Open",
      "revert": "Put Unity's value back",
      "notInUnity": "New here — Unity doesn't have this step or page yet",
      "sortAsc": "Sort A → Z",
      "sortDesc": "Sort Z → A",
      "contains": "Contains…",
      "findValue": "Find value…",
      "selectAll": "Select all",
      "selectNone": "Clear",
      "clearFilter": "Clear filter",
      "filterColumn": "Sort and filter {{column}}",
      "noRows": "No rows match.",
      "badValue": "“{{text}}” doesn't fit {{column}}",
      "readOnly": "These cells can't be changed here",
      "tooMany": "Paste at most {{max}} cells at a time",
      "copyFailed": "Couldn't copy — the browser blocked the clipboard"
    }
  }
}
